import { render } from "./about-news.vue?vue&type=template&id=f1353d30"
import script from "./about-news.vue?vue&type=script&lang=js"
export * from "./about-news.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__